<template>
    <InstructorMainLayout v-if="validTheme(Enums.USER_TYPE.INSTRUCTOR)" :leftSidebar="leftSidebar" :rightSidebar="rightSidebar"><slot></slot></InstructorMainLayout>
    <TeacherMainLayout v-else-if="validTheme(Enums.USER_TYPE.TEACHER)" :leftSidebar="leftSidebar" :rightSidebar="rightSidebar"><slot></slot></TeacherMainLayout>
    <StudentMainLayout v-else-if="validTheme(Enums.USER_TYPE.STUDENT, false)" :leftSidebar="leftSidebar" :rightSidebar="rightSidebar"><slot></slot></StudentMainLayout>
    <CandidateMainLayout v-else-if="validTheme(Enums.USER_TYPE.CANDIDATE, false)" :leftSidebar="leftSidebar" :rightSidebar="rightSidebar"><slot></slot></CandidateMainLayout>
    <StudentPackageMainLayout v-else-if="validTheme(Enums.USER_TYPE.STUDENT, true)" :leftSidebar="leftSidebar" :rightSidebar="rightSidebar"><slot></slot></StudentPackageMainLayout>
    <CandidatePackageMainLayout v-else-if="validTheme(Enums.USER_TYPE.CANDIDATE, true)" :leftSidebar="leftSidebar" :rightSidebar="rightSidebar"><slot></slot></CandidatePackageMainLayout>
    <ClassicMainLayout v-else :leftSidebar="leftSidebar" :rightSidebar="rightSidebar"><slot></slot></ClassicMainLayout>
</template>
<script>
    import { reactive, toRefs, computed, onMounted  } from "vue";
    import { useStore } from "vuex";

    import { Constants } from "@/helpers/constants";
    import { appData, C } from "@/helpers/global";

    import ClassicMainLayout from "@/layouts/classic/MainLayout.vue";
    
    import InstructorMainLayout from "@/layouts/instructor/MainLayout.vue";
    import TeacherMainLayout from "@/layouts/teacher/MainLayout.vue";
    import StudentMainLayout from "@/layouts/student/MainLayout.vue";
    import CandidateMainLayout from "@/layouts/candidate/MainLayout.vue";
    import StudentPackageMainLayout from "@/layouts/student-package/MainLayout.vue";
    import CandidatePackageMainLayout from "@/layouts/candidate-package/MainLayout.vue";

    import { StoreUser } from "@/store/constants";

    export default {
        components: {
            ClassicMainLayout,
            InstructorMainLayout,
            TeacherMainLayout,
            StudentMainLayout,
            CandidateMainLayout,
            StudentPackageMainLayout,
            CandidatePackageMainLayout,
        },
        props: {
            leftSidebar: {
                type:Number,
                default :0,
            },
        },
        unmounted() { this.bus.leave(); },
        setup() {
            const store = useStore();

            const e = reactive({
                bus: appData.eventBus(Constants.Key.RightSidebar),
                rightSidebar: computed(() => {
                    return C.Int(e.bus.get(Constants.Key.RightSidebar)?.type) > 0;
                }),
                user: computed(() => {
                    return store.getters[StoreUser.get];
                }),
                validTheme(type, isPackage) {
                    if (isPackage == undefined) {
                        return type == e.userType;
                    }
                    return (type == e.userType && e.isBuyPackage == isPackage);
                },
                userType: computed(() => {
                    return C.Int(e.user.userType);
                }),
                isBuyPackage: computed(() => {
                    return C.Bool(e.user.isBuyPackage);
                }),
            });
            return { ...toRefs(e) };
        },
    };
</script>